module.exports = __webpack_public_path__ + "static/media/3_col_4.c1ab7ec9.jpg";